import React from "react";

const Footer = () => {
  return (
    <>
      <div className="footer bg-dark text-light p-3">
        <h6 className="text-center text-white">
          All rights reserved &copy; 2023 Prakash & Company Pvt Ltd.
        </h6>
      </div>
    </>
  );
};

export default Footer;
